import type { BotType, DonationMode, EggIncubation, Slot, SurvivorFavorMode, WinCondition } from '../../types/game'

export interface HostDraft {
  roomName: string
  publicOffers: boolean
  unlimitedQueenTrade: boolean
  donationMode: DonationMode
  eggIncubation: EggIncubation
  incrementalBroodChamberCost: boolean
  infectionSpread: boolean
  survivorFavorMode: SurvivorFavorMode
  winCondition: WinCondition
  slotStates: Record<string, Slot>
  botTypes: Record<string, BotType>
}

export function defaultHostDraft(alias: string): HostDraft {
  return {
    roomName: `${alias}'s Game`,
    publicOffers: true,
    unlimitedQueenTrade: false,
    donationMode: 'non_refusable',
    eggIncubation: 'year',
    incrementalBroodChamberCost: true,
    infectionSpread: true,
    survivorFavorMode: 'graded',
    winCondition: 'built_and_clean',
    slotStates: {
      orange: 'open',
      red: 'open',
      yellow: 'open',
      white: 'open',
    },
    botTypes: {},
  }
}
